module.exports = __webpack_public_path__ + "static/img/豆包.3341eba6.png";